<template>
  <div>
    <!-- 新增按钮 -->
    <Input
      v-model="searchId"
      placeholder="输入用户ID"
      style="width: 200px; margin-right: 10px"
    />
    <Input
      v-model="searchName"
      placeholder="输入用户昵称"
      style="width: 200px; margin-right: 10px"
    />
    <Input
      v-model="searchPhone"
      placeholder="输入用户手机号"
      style="width: 200px; margin-right: 10px"
    />

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择注册时间"
      style="width: 200px"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <Modal v-model="modal1" title="封号" width="300">
      <div>
        <Input
          v-if="isfengjin"
          v-model="beizhu"
          placeholder="请输入封号备注"
          style="width: 200px"
        />
        <div v-if="isfengjin == false">确定解封该用户?</div>
      </div>
      <div slot="footer">
        <Button @click="submitJiefeng" v-if="isfengjin == false"
          >确认解封</Button
        >
        <Button @click="submitFenghao" v-if="isfengjin">确认封号</Button>
        <Button @click="cancelFenghao">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modal2" title="充值" width="400">
      <div>
        <RadioGroup v-model="rechargeType" :disabled="currencyType === '礼品'">
          <Radio label="充值" :disabled="currencyType === '礼品'">充值</Radio>
          <Radio label="扣除" :disabled="currencyType === '礼品'">扣除</Radio>
        </RadioGroup>

        <Select
          v-model="currencyType"
          placeholder="选择能量或金币"
          style="width: 200px; margin-top: 10px"
          @on-change="handleCurrencyTypeChange"
        >
          <Option value="能量">能量</Option>
          <Option value="金币">金币</Option>
          <Option value="礼品">礼品</Option>
        </Select>

        <Input
          v-if="currencyType !== '礼品'"
          v-model="amount"
          placeholder="输入币数或能量数"
          style="width: 200px; margin-top: 10px"
        />

        <Input
          v-if="currencyType === '礼品'"
          v-model="giftId"
          placeholder="输入礼品ID"
          style="width: 200px; margin-top: 10px"
        />

        <p style="margin-top: 10px" v-if="currencyType === '能量'">
          操作后能量:
          {{
            rechargeType == "充值"
              ? (parseInt(amount) || 0) + (parseInt(selUser.integral) || 0)
              : (parseInt(selUser.integral) || 0) - (parseInt(amount) || 0)
          }}
        </p>
        <p style="margin-top: 10px" v-if="currencyType === '金币'">
          操作后余额:
          {{
            rechargeType == "充值"
              ? (parseInt(amount) || 0) + (parseInt(selUser.balance) || 0)
              : (parseInt(selUser.balance) || 0) - (parseInt(amount) || 0)
          }}
        </p>
        <Input
          v-model="reasontxt"
          placeholder="输入理由"
          style="width: 200px; margin-top: 10px"
        />
      </div>

      <div slot="footer">
        <Button @click="submitRecharge">确认</Button>
        <Button @click="cancelRecharge">取消</Button>
      </div>
    </Modal>
    <userDetailModal
      :visible="modal3"
      :user_id="clickuserid"
      @guanbimodal="guanbimodal"
    />
    <userInfoModal
      :visible="modal4"
      :user_id="clickuserid"
      @guanbimodal="guanbimodal"
    />

    <div class="kf-float-btn" @click="toggleKfChat">
      <img
        class="kf-avatar"
        :src="kfAvatarUrl"
        alt="客服助手"
      />
    </div>

    <div
      v-if="kfChatVisible"
      class="kf-chat"
      :class="{ minimized: kfChatMinimized }"
    >
      <div class="kf-chat__header">
        <span>
          客服助手
          <i class="kf-status" :class="{ online: kfCindyOnline }"></i>
          <small>{{ kfConnectionText }}</small>
        </span>
        <div class="kf-chat__header-actions">
          <Button size="small" @click.stop="kfChatMinimized = !kfChatMinimized">
            {{ kfChatMinimized ? "展开" : "缩小" }}
          </Button>
          <Button size="small" @click.stop="closeKfChat">关闭</Button>
        </div>
      </div>

      <div v-show="!kfChatMinimized" class="kf-chat__body" ref="kfChatBody">
        <div
          v-for="(m, idx) in kfMessages"
          :key="idx"
          class="kf-msg"
          :class="m.role"
        >
          <div class="kf-msg__bubble">
            <pre class="kf-msg__text">{{ m.text }}</pre>
          </div>
        </div>
      </div>

      <div v-show="!kfChatMinimized" class="kf-chat__footer">
        <Input
          v-model="kfInput"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="输入话术，回车发送（Shift+Enter换行）"
          @on-keydown="onKfKeydown"
        />
        <div class="kf-chat__footer-actions">
          <Button
            type="primary"
            :loading="kfLoading"
            :disabled="kfLoading"
            @click="sendKf"
          >
            发送
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cmsUserList, cmsUserBanned } from "../../api/user";
import { cmsMoneyApplyadd } from "../../api/moneyApply";
import {
  getCustomerSupportTicket,
} from "../../api/customerSupport";
import CindyRelayClient from "../../utils/cindyRelayClient";
import userDetailModal from "./userDetailModal.vue"; // 引入刚刚创建的封号组件
import userInfoModal from "./userInfoModal.vue";
import { formatOssUrl } from "@/utils";

export default {
  components: { userDetailModal, userInfoModal },
  data() {
    return {
      selUser: {},
      modal4: false,
      modal3: false,
      modal2: false, // 控制充值弹窗的显示与否
      rechargeType: "充值", // 充值或扣除的类型，"recharge"表示充值，"deduct"表示扣除
      currencyType: "金币", // 选择的类型，可以是"points"或"coins"
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      giftId: "", // 添加礼品ID字段
      isfengjin: false,
      modal1: false,
      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "用户昵称",
          key: "user_nickname",
        },
        {
          title: "真实姓名",
          key: "idname",
        },
        {
          title: "头像",

          key: "head_photo",
          render: (h, params) => {
            const url = params.row.head_photo == null ?"" : params.row.head_photo;
            return h("img", {
              attrs: {
                src: formatOssUrl(url)   
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "等级",
          key: "user_level",
        },
        {
          title: "余额",
          key: "balance",
        },
        {
          title: "能量",
          key: "integral",
        },
        {
          title: "注册时间",
          key: "register_time",
        },
        {
          title: "状态",
          key: "user_status",
          render: (h, params) => {
            const user_status = params.row.user_status;
            return h(
              "span",
              user_status === 0 ? "正常" : user_status === 1 ? "封禁" : "注销"
            );
          },
        },
        {
          title: "封号备注",
          key: "bannedtxt",
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickuserid = params.row.user_id.toString();
                      if (params.row.user_status == 0) {
                        this.isfengjin = true;
                      } else {
                        this.isfengjin = false;
                      }
                      this.modal1 = true;
                    },
                  },
                },
                params.row.user_status == 0 ? "封禁" : "解封"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickuserid = params.row.user_id.toString();
                      this.modal4 = true;
                    },
                  },
                },
                "用户信息"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickuserid = params.row.user_id.toString();
                      console.log("====" + this.clickuserid);
                      this.modal3 = true;
                    },
                  },
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.selUser = params.row;
                      this.modal2 = true;
                    },
                  },
                },
                "充值"
              ),
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchPhone: "",
      current: 1,
      total: 0,

      kfAvatarUrl:
        "https://ossimg.zhizhuawulian.com/download/kef.jpg",
      kfChatVisible: false,
      kfChatMinimized: false,
      kfInput: "",
      kfLoading: false,
      kfSessionId: "",
      kfRelay: null,
      kfConnected: false,
      kfCindyOnline: false,
      kfPending: {},
      kfActiveRequestId: "",
      kfMessages: [
        {
          role: "assistant",
          text: "你好，我是客服助手。请输入你的话术，我会根据系统数据返回结果。",
        },
      ],
    };
  },
  mounted() {
    this.queryGoods();
    this.kfSessionId = this.getKfSessionId();
    this.initKfRelay();
  },
  beforeDestroy() {
    if (this.kfRelay) this.kfRelay.close();
  },
  computed: {
    kfConnectionText() {
      if (!this.kfConnected) return "连接中";
      return this.kfCindyOnline ? "Cindy 在线" : "等待本机 Cindy";
    },
  },
  methods: {
    makeKfId() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    },
    getKfSessionId() {
      const key = "tewei-cindy-support-session";
      let value = window.sessionStorage.getItem(key);
      if (!value) {
        value = this.makeKfId();
        window.sessionStorage.setItem(key, value);
      }
      return value;
    },
    initKfRelay() {
      this.kfRelay = new CindyRelayClient({
        getCredentials: async () => {
          const response = await getCustomerSupportTicket({
            sessionId: this.kfSessionId || this.getKfSessionId(),
          });
          const data = response && response.data;
          if (!data || !data.ticket || !data.wsUrl) {
            throw new Error("后端未返回 Cindy 连接凭证");
          }
          return data;
        },
        onEvent: message => this.onKfRelayEvent(message),
      });
      this.kfRelay.connect().catch(error => {
        this.kfConnected = false;
        console.error("Cindy relay connect failed", error);
      });
    },
    onKfRelayEvent(message) {
      if (!message || !message.type) return;
      if (message.type === "auth_ok") {
        this.kfConnected = true;
        this.kfCindyOnline = Boolean(message.cindy_online);
        return;
      }
      if (message.type === "presence") {
        this.kfCindyOnline = Boolean(message.cindy_online);
        return;
      }
      if (message.type === "offline") {
        this.kfConnected = false;
        return;
      }
      const requestId = message.request_id;
      const pending = requestId && this.kfPending[requestId];
      if (!pending) return;
      if (message.type === "accepted") {
        pending.text = message.cindy_online
          ? "任务已进入 Cindy，正在开始分析…"
          : "任务已排队，等待本机 Cindy 上线…";
      } else if (message.type === "status") {
        pending.text = message.message || "Cindy 正在处理…";
      } else if (message.type === "progress") {
        pending.text = message.message || "Cindy 正在分析，请稍候…";
      } else if (message.type === "response") {
        pending.text = message.answer || "Cindy 已完成，但没有返回文字。";
        pending.pending = false;
        this.finishKfRequest(requestId);
      } else if (message.type === "error" || message.type === "protocol_error") {
        pending.text = `请求失败：${message.message || message.code || "Cindy 执行失败"}`;
        pending.pending = false;
        this.finishKfRequest(requestId);
      }
      this.$forceUpdate();
      this.$nextTick(() => this.scrollKfToBottom());
    },
    finishKfRequest(requestId) {
      this.$delete(this.kfPending, requestId);
      if (this.kfActiveRequestId === requestId) {
        this.kfActiveRequestId = "";
        this.kfLoading = false;
      }
    },
    toggleKfChat() {
      this.kfChatVisible = !this.kfChatVisible;
      if (this.kfChatVisible) {
        this.kfChatMinimized = false;
        if (this.kfRelay) this.kfRelay.connect().catch(() => {});
        this.$nextTick(() => this.scrollKfToBottom());
      }
    },
    closeKfChat() {
      this.kfChatVisible = false;
    },
    scrollKfToBottom() {
      const el = this.$refs.kfChatBody;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    },
    onKfKeydown(e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        this.sendKf();
      }
    },
    async sendKf() {
      const text = (this.kfInput || "").trim();
      if (!text) return;
      if (this.kfLoading) return;

      const history = this.kfMessages
        .filter(item => !item.pending)
        .slice(-12)
        .map(item => ({ role: item.role, text: item.text }));
      this.kfMessages.push({ role: "user", text });
      const pending = {
        role: "assistant",
        text: "已提交，等待本机 Cindy 领取任务…",
        pending: true,
      };
      this.kfMessages.push(pending);
      this.kfInput = "";
      this.kfLoading = true;
      this.$nextTick(() => this.scrollKfToBottom());

      try {
        const requestId = this.makeKfId();
        this.$set(this.kfPending, requestId, pending);
        this.kfActiveRequestId = requestId;
        if (!this.kfRelay) this.initKfRelay();
        await this.kfRelay.ask(text, history, requestId);
      } catch (e) {
        const msg = typeof e === "string" ? e : (e && e.message) || "请求失败";
        pending.text = `请求失败：${msg}`;
        pending.pending = false;
        this.kfLoading = false;
        if (this.kfActiveRequestId) this.$delete(this.kfPending, this.kfActiveRequestId);
        this.kfActiveRequestId = "";
      } finally {
        this.$nextTick(() => this.scrollKfToBottom());
      }
    },
    submitFenghao() {
      cmsUserBanned({
        user_id: this.clickuserid,
        bannedtxt: this.beizhu,
        user_status: 1,
      })
        .then((response) => {
          this.modal1 = false;
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        })
        .catch((error) => {
          console.error(error);
        });
    },
    submitJiefeng() {
      cmsUserBanned({
        user_id: this.clickuserid,
        bannedtxt: "",
        user_status: 0,
      })
        .then((response) => {
          this.modal1 = false;
          this.queryGoods(); // 直接调用查询函数，不用重复逻辑
        })
        .catch((error) => {
          console.error(error);
        });
    },
    guanbimodal() {
      this.modal3 = false;
      this.modal4 = false;
    },
    cancelFenghao() {
      this.modal1 = false;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsUserList(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        user_id: this.searchId || undefined,
        username: this.searchName || undefined,
        userphone: this.searchPhone || undefined,
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
    submitRecharge() {
      // 提交充值或扣除操作的逻辑
      let actionType = this.rechargeType === "充值" ? 0 : 1;
      let currency = this.currencyType === "金币" ? 0 : 1;
      if(this.currencyType === '礼品') {
        actionType = 0;
        currency = 2;
        if(this.giftId == "" || this.giftId == undefined || this.giftId == null) {
          this.$Message.error("礼品ID不能为空");
          return;
        }
      }
      if (this.amount <= 0 && this.currencyType !== '礼品') {
        this.$Message.error("充值或扣除金额必须大于0");
        return;
      }
      if (
        this.rechargeType === "扣除" &&
        this.currencyType === "金币" &&
        this.amount > this.selUser.balance
      ) {
        this.$Message.error("扣除金额不能大于余额");
        return;
      }

      if (
        this.rechargeType === "扣除" &&
        this.currencyType === "能量" &&
        this.amount > this.selUser.integral
      ) {
        this.$Message.error("扣除能量不能大于余额");
        return;
      }

      // 这里可以调用 API 提交数据
      if (this.currencyType === '礼品') {
        cmsMoneyApplyadd({
          user_id: this.selUser.user_id,
          applycoin: this.giftId,
          applytype: currency,
          applystatus: actionType,
          user_name: this.selUser.user_nickname,
          reasontxt: this.reasontxt,
        })
          .then((response) => {
            this.$Message.success(`申请成功,等待审核`);
            this.modal2 = false;
          })
          .catch((error) => {
            this.$Message.error(`${actionType} ${currency} 失败`);
          });
      } else {
        cmsMoneyApplyadd({
          user_id: this.selUser.user_id,
          applycoin: this.amount,
          applytype: currency,
          applystatus: actionType,
          user_name: this.selUser.user_nickname,
          reasontxt: this.reasontxt,
        })
          .then((response) => {
            this.$Message.success(`申请成功,等待审核`);
            this.modal2 = false;
          })
          .catch((error) => {
            this.$Message.error(`${actionType} ${currency} 失败`);
          });
      }
    },

    cancelRecharge() {
      this.modal2 = false; // 关闭弹窗
    },
    handleCurrencyTypeChange(value) {
      if (value === '礼品') {
        this.rechargeType = '充值';
        this.amount = '';
      } else {
        this.giftId = '';
        this.amount = 0;
      }
    },
  },
};
</script>

<style scoped>
.kf-float-btn {
  position: fixed;
  right: 16px;
  bottom: 120px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
}

.kf-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.kf-chat {
  position: fixed;
  right: 16px;
  bottom: 96px;
  width: 720px;
  max-width: calc(100vw - 48px);
  height: 680px;
  max-height: calc(100vh - 120px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  z-index: 10000;
  display: flex;
  flex-direction: column;
}

.kf-chat.minimized {
  height: 48px;
  width: 420px;
}

.kf-chat__header {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  background: #2d8cf0;
  color: #fff;
}

.kf-chat__header-actions {
  display: flex;
  gap: 6px;
}

.kf-status {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin: 0 4px 0 8px;
  border-radius: 50%;
  background: #ff9900;
}

.kf-status.online {
  background: #19be6b;
}

.kf-chat__header small {
  font-weight: normal;
  opacity: 0.9;
}

.kf-chat__body {
  flex: 1;
  min-height: 0;
  padding: 10px;
  overflow-y: auto;
  overflow-x: auto;
  background: #f7f7f7;
}

.kf-chat__footer {
  padding: 10px;
  border-top: 1px solid #eee;
  background: #fff;
}

.kf-chat__footer-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.kf-msg {
  display: flex;
  margin-bottom: 10px;
}

.kf-msg.user {
  justify-content: flex-end;
}

.kf-msg.assistant {
  justify-content: flex-start;
}

.kf-msg__bubble {
  max-width: 88%;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff;
}

.kf-msg.assistant .kf-msg__bubble {
  width: 100%;
  max-width: 100%;
}

.kf-msg.user .kf-msg__bubble {
  background: #d6ecff;
}

.kf-msg__text {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-family: inherit;
}

@media (max-width: 768px) {
  .kf-chat,
  .kf-chat.minimized {
    right: 12px;
    bottom: 12px;
    width: calc(100vw - 24px);
    max-width: none;
  }

  .kf-chat {
    height: calc(100vh - 24px);
    max-height: none;
  }
}
</style>
